import { createReducer, on } from '@ngrx/store';
import { NotificationProfileSwitchActions } from './notification-profile-switch.actions';
import {
  NotificationProfileSwitchState,
  notificationProfileSwitchState
} from './notification-profile-switch.state';

export const notificationProfileSwitchReducer = createReducer(
  notificationProfileSwitchState,
  on(
    NotificationProfileSwitchActions.reset,
    (): NotificationProfileSwitchState => ({
      notificationPayload: notificationProfileSwitchState.notificationPayload
    })
  ),
  on(
    NotificationProfileSwitchActions.setNotificationPayload,
    (state, payload): NotificationProfileSwitchState => ({
      ...state,
      notificationPayload: payload
    })
  )
);
